export const FILTER_ITEM = [
  '세미나',
  '커리어',
  '교육',
  '온라인',
  '오프라인',
  '경진대회',
  '컨퍼런스',
  '해커톤',
  '웹/프론트엔드',
  '백엔드',
  '머신러닝/AI',
  '데이터',
  '클라우드',
  '인프라/DevOps',
  '오픈소스',
  '모바일',
  '프레임워크',
  '기타',
];
